import React, { createContext, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

export const LanguageContext = createContext(undefined);

export const LanguageContextProvider = ({ children }) => {
  const languages = {
    en: { nativeName: "English" },
    it: { nativeName: "Italian" },
    fr: { nativeName: "French" },
    ar: { nativeName: "Arabic" },
  };
  const { t, i18n } = useTranslation();

  const onClickLanguageChange = (language) => {
    i18n.changeLanguage(language); //change the language
  };


  useEffect(() => {
    const dir = i18n.dir(i18n.language);
    document.documentElement.dir = dir;
 }, [i18n, i18n.language]);

  return (
    <LanguageContext.Provider
      value={{ t, i18n, onClickLanguageChange, languages }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguageContext = () => useContext(LanguageContext);
